import React, { useState, useCallback, useEffect } from "react";
import { capitalize } from "lodash";
import * as moment from "moment";

import "./FlexPackage.css";
import downred from "../../../../assets/downred.svg";
import upgreen from "../../../../assets/upgreen.svg";
import TransactionDetails from "../../../main/TransactionDetails";
import { Util } from "../../../../../../../helpers/util";
import { $api } from "../../../../../../../helpers/$api";
import { toast } from "react-toastify";

const TuitionFeeDetails = ({ setChange, data: plan }) => {
  const { currency } = Util.getCurrency();
  const [recentTransactions, setRecentTransactions] = useState([]);
  const canWithdraw = moment().format("YYYY-MM-DD") === plan.next_withdrawal;

  const getUserSavestTransactions = useCallback(async () => {
    if (plan) {
      const res = await $api.user.getUserSavestTransactions();

      setRecentTransactions(res.splice(0, 5));
    }
  }, [setRecentTransactions, plan]);

  useEffect(() => {
    getUserSavestTransactions();
  }, [getUserSavestTransactions]);

  return (
    <div className="tuition-fee-body">
      <div className="tuition-section">
        <div className="tuition-header">
          <h5>
            {plan.name_of_plan || `${capitalize(plan.saving_type)} saving plan`}
          </h5>
          <p onClick={() => setChange(1, plan.id)}>Earnings Summary</p>
        </div>
        <div className="tutiton-fee-details">
          <div className="tuition-flex">
            <div className="">
              <p className="amount-saved-details">Amount Saved</p>
              <h5 className="amount-saved-naira">
                {currency} {Util.formatMoneyNumber(plan.wallet)}
              </h5>
            </div>
            <div>
              <p className="amount-saved-details">Interest</p>
              <h5 className="amount-saved-naira">
                {currency} {Util.formatMoneyNumber(plan.wallet * 0.07)}
              </h5>
            </div>
            <div className="tuition-buttons">
              <div>
                <button
                  onClick={() => {
                    if (canWithdraw) {
                      setChange(3);
                      return;
                    }

                    toast.warn(
                      `Next withdrawal in ${moment(plan.next_withdrawal).diff(
                        moment(),
                        "days"
                      )} days`
                    );
                  }}
                  className="withdraw-button-tuition mb-1"
                  title={
                    !canWithdraw &&
                    `Next withdrawal in ${moment(plan.next_withdrawal).diff(
                      moment(),
                      "days"
                    )} days`
                  }
                >
                  Withdraw
                </button>
              </div>
              <button
                onClick={() => setChange(2)}
                className="withdraw-button-tuition mt-1"
              >
                Top up
              </button>
            </div>
          </div>
        </div>
        <div className="available-wallet-balance mt-4">
          <div className="available-balance-section">
            <div className="investamount">
              <p className="flex-main">Available Balance:</p>
              <p className="pricetag">
                {currency} {Util.formatMoneyNumber(plan.wallet)}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Interest:</p>
              <p className="pricetag">7%</p>
            </div>
            <div className="investamount">
              <p className="flex-main">Start Date:</p>
              <p className="flex-mini">
                {moment(plan.start_date).format("MMM DD, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Maturity Date:</p>
              <p className="flex-mini">
                {moment(plan.next_withdrawal).format("MMM DD, YYYY")}
              </p>
            </div>
            <div className="investamount">
              <p className="flex-main">Savest Type:</p>
              <p className="flex-mini" style={{ textTransform: "capitalize" }}>
                {plan.saving_type}
              </p>
            </div>
          </div>
        </div>
        <div className="flexible-plan-note tuition-note">
          <p className="flexible-plan-note-p">
            {" "}
            <span>Note:</span> Kindly note that your funds and interest would be
            locked for the stated period of time, you won’t have access to it
            until the maturity day.
          </p>
        </div>
        <div className="tuition-debit-transaction">
          <p>Transaction History</p>
          <div className="deposit-main">
            {recentTransactions.map((trans) => {
              const isBearish = trans.type.toLowerCase().includes("withdraw");

              return (
                <div key={trans.id}>
                  <TransactionDetails
                    icon={isBearish ? downred : upgreen}
                    title={trans.description}
                    date={moment(trans.created_at).format("MMM DD, YYYY")}
                    amount={`${
                      isBearish ? "- " : ""
                    }${currency} ${Util.formatMoneyNumber(trans.amount)} `}
                    style={{ color: isBearish ? "#ee5253" : "green" }}
                  />

                  <div className="hr"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TuitionFeeDetails;
